import { useQuery } from "@tanstack/react-query";
import i18n from "../../../localization/i18n";
import { fetchFullArticleDetails } from "../../../services/apiService";
import { useUserStore } from "../../../store/userStore";

const staleTime =  60 * 60 * 1000; // 60 minutes

export function useFullArticleDetails(articleId: string) {
  const currentLanguage = i18n.language;
  const { user } = useUserStore();
  
  const isEnabled = Boolean(user?.firebaseUser?.uid);

  return useQuery({
    queryKey: ["article-details", articleId, currentLanguage, user?.firebaseUser?.uid],
    queryFn:  () => {
      if (!isEnabled) {
        return Promise.resolve(null)
      }
      return fetchFullArticleDetails(articleId);
    },
    staleTime: staleTime, // 60 minutes
    refetchOnWindowFocus: false,
    enabled: !!articleId, // Only run query if articleId is provided
  });
}
